import React from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import { Paper } from "@material-ui/core";
import GroupWidgetMapping from "./GroupWidgetMapping";
import "./configuration.less";
import FacilityPerformanceReportMaster from "./FacilityPerformanceReportMaster";
import ConfigureWidgets from "./configureWidget";
import GroupSectionMapping from "./GroupSectionMapping";
import ConfigureUserToDC from "./configureUserToDC";
import ConfigureGuardForcePatrols from "./ConfigureGuardForcePatrols";
import {
  IsAdmin,
  IsSectionVisible,
  GetUserConfiguration
} from "../../utils/helper";
import { SECTIONS } from "../../constants/appConstants";
import ConfigureEmpProperty from "./ConfigureEmp";
import ConfigureRequestTypeDepartmentAndSiteMapping from "./ConfigureRequestTypeDepartmentAndSiteMapping";
import ConfigureDC from "./ConfigureDC";
import ConfigurationRoutingAndNotification from "./ConfigurationRoutingAndNotification/ConfigurationRoutingAndNotification";
import MenuSettings from "./MenuSettings/MenuSettings";

export default class Configurations extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedMenu: IsAdmin()
        ? 0
        : IsSectionVisible(
            SECTIONS.CONFIGURATION,
            SECTIONS.CONFIGURE_GROUP_WIDGET
          )
        ? 0
        : IsSectionVisible(SECTIONS.CONFIGURATION, SECTIONS.ADD_UPDATE_WIDGET)
        ? 2
        : IsSectionVisible(
            SECTIONS.CONFIGURATION,
            SECTIONS.CONFIGURE_FACILITY_PERFORMANCE
          )
        ? 1
        : IsSectionVisible(
            SECTIONS.CONFIGURATION,
            SECTIONS.CONFIGURE_DATA_CENTER
          )
        ? 6
        : 3
    };
  }

  componentWillMount() {}

  componentDidMount() {}

  /**
   * render tab according tab selection
   * @param {*} group
   * @returns
   */
  renderPage = group => {
    const { selectedMenu } = this.state;
    switch (selectedMenu) {
      case 0:
        return <GroupWidgetMapping group={group} />;
      case 1:
        return (
          <FacilityPerformanceReportMaster
            group={group}
          />
        );
      case 2:
        return <ConfigureWidgets group={group} />;
      case 3:
        return <GroupSectionMapping group={group} />;
      case 4:
        return (
          <ConfigureGuardForcePatrols
            group={group}
          />
        );
      case 5:
        return <ConfigureUserToDC group={group} />;
      case 6:
        return <ConfigureDC group={group} />;
      case 7:
        return <ConfigureEmpProperty group={group} />;
      case 9:
        return <ConfigureRequestTypeDepartmentAndSiteMapping group={group} />;
      case 10:
        return <ConfigurationRoutingAndNotification group={group} />;
      case 11:
          return <MenuSettings group={group} />;
    }
  };

  render() {
    const group = (GetUserConfiguration().groups[0] || {}).objectId;
    const { selectedMenu } = this.state;
    return (
      <div className={"row configuration-container"}>
        <div className={"col-xs-12 col-sm-12 col-md-3 col-lg-3"}>
          <div className={"addwidget-container"}>
            <div className={"header row"}>
              {" "}
              <div className={"col-xs-11"}>{"Configurations"}</div>
            </div>
            <div className={"row widget-content"}>
              <List
                component={"nav"}
                aria-label={"mailbox folders"}
                className={"ConfigureMenu"}
              >
                {" "}
                {IsSectionVisible(
                  SECTIONS.CONFIGURATION,
                  SECTIONS.ADD_UPDATE_WIDGET
                ) && (
                  <>
                    {" "}
                    <ListItem
                      divider
                      button
                      selected={selectedMenu == 2}
                      onClick={() => this.setState({ selectedMenu: 2 })}
                    >
                      <ListItemText fontSize={"small"} primary={"Master Widgets"} />
                    </ListItem>
                    <Divider />
                  </>
                )}
                {IsSectionVisible(
                  SECTIONS.CONFIGURATION,
                  SECTIONS.CONFIGURE_GROUP_WIDGET
                ) && (
                  <>
                    <ListItem
                      button
                      selected={selectedMenu == 0}
                      onClick={() => this.setState({ selectedMenu: 0 })}
                    >
                      <ListItemText
                        fontSize={"small"}
                        primary={"Group Widgets Mapping"}
                      />
                    </ListItem>
                    <Divider />
                  </>
                )}
                {IsSectionVisible(
                  SECTIONS.CONFIGURATION,
                  SECTIONS.CONFIGURE_FACILITY_PERFORMANCE
                ) && (
                  <>
                    <ListItem
                      divider
                      button
                      selected={selectedMenu == 1}
                      onClick={() => this.setState({ selectedMenu: 1 })}
                    >
                      <ListItemText
                        fontSize={"small"}
                        primary={"Facility Performance Views"}
                      />
                    </ListItem>
                    <Divider />
                  </>
                )}
                {IsAdmin() && (
                  <ListItem
                    divider
                    button
                    selected={selectedMenu == 3}
                    onClick={() => this.setState({ selectedMenu: 3 })}
                  >
                    <ListItemText
                      fontSize={"small"}
                      primary={"Group Access Permissions"}
                    />
                  </ListItem>
                )}
                {IsAdmin() && (
                  <>
                    <ListItem
                      divider
                      button
                      selected={selectedMenu == 4}
                      onClick={() => this.setState({ selectedMenu: 4 })}
                    >
                      <ListItemText
                        fontSize={"small"}
                        primary={"Configure Patrols"}
                      />
                    </ListItem>
                  </>
                )}
                {IsSectionVisible(
                  SECTIONS.CONFIGURATION,
                  SECTIONS.CONFIGURE_DATA_CENTER
                ) && (
                  <>
                    <ListItem
                      divider
                      button
                      selected={selectedMenu == 6}
                      onClick={() => this.setState({ selectedMenu: 6 })}
                    >
                      <ListItemText
                        fontSize={"small"}
                        primary={"Configure Data Centers"}
                      />
                    </ListItem>
                  </>
                )}
                {IsSectionVisible(
                  SECTIONS.CONFIGURATION,
                  SECTIONS.CONFIGURE_EMPLOYEE_AND_DATA_CENTER
                ) && (
                  <>
                    <ListItem
                      divider
                      button
                      selected={selectedMenu == 7}
                      onClick={() => this.setState({ selectedMenu: 7 })}
                    >
                      <ListItemText
                        fontSize={"small"}
                        primary={"Configure Employee and Data Center"}
                      />
                    </ListItem>
                  </>
                )}
                {IsSectionVisible(
                  SECTIONS.CONFIGURATION,
                  SECTIONS.CONFIGURE_REQUEST_TYPE_DEPARTMENT_AND_DATA_CENTER
                ) && (
                  <>
                    <ListItem
                      divider
                      button
                      selected={selectedMenu == 9}
                      onClick={() => this.setState({ selectedMenu: 9 })}
                    >
                      <ListItemText
                        fontSize={"small"}
                        primary={"Configure Request Type, Department and Data Center"}
                      />
                    </ListItem>
                  </>
                )}
                {IsSectionVisible(
                  SECTIONS.CONFIGURATION,
                  SECTIONS.CONFIGURE_ROUTING_AND_NOTIFICATION
                ) && (
                  <>
                    <ListItem
                      divider
                      button
                      selected={selectedMenu == 10}
                      onClick={() => this.setState({ selectedMenu: 10 })}
                    >
                      <ListItemText
                        fontSize={"small"}
                        primary={"Configure Routing and Notification"}
                      />
                    </ListItem>
                  </>
                )}
                 {IsSectionVisible(
                  SECTIONS.CONFIGURATION,
                  SECTIONS.CONFIGURE_ROUTING_AND_NOTIFICATION
                ) && (
                  <>
                    <ListItem
                      divider
                      button
                      selected={selectedMenu == 11}
                      onClick={() => this.setState({ selectedMenu: 11 })}
                    >
                      <ListItemText
                        fontSize={"small"}
                        primary={"Menu Settings"}
                      />
                    </ListItem>
                  </>
                )}
              </List>
            </div>
          </div>
        </div>
        <div className={"col-xs-12 col-sm-12 col-md-9 col-lg-9"}>
          <div className={"addwidget-container row"}>
            <Paper className={"col-xs-12"}>{this.renderPage(group)}</Paper>
          </div>
        </div>
      </div>
    );
  }
}
